import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SideNavService {

  constructor() { }


  private showBubble$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  showBubble = this.showBubble$.asObservable();


  setShowBubble(ShowBubble: boolean) {
    this.showBubble$.next(ShowBubble);
  } get getShowBubble(): boolean {
    return this.showBubble$.value;
  }


}
